export { default } from "./ScoreTutorial";
